import React from 'react';

import * as S from './WebLinkItem.styles';

const FAVICON_SERVICE_BASE = 'https://www.google.com/s2/favicons';

export const createFaviconUrl = (domain: string, size: number = 18) => {
  const params = new URLSearchParams({
    domain,
    sz: size.toString(),
  });
  return `${FAVICON_SERVICE_BASE}?${params.toString()}`;
};

interface WebLinksItemProps {
  url: string;
  shouldFetch: boolean;
}

export const WebLinkItem = ({ url, shouldFetch }: WebLinksItemProps) => {
  if (!shouldFetch) {
    return null;
  }

  const favicon = createFaviconUrl(url);

  const handleItemClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <S.ItemContainer onClick={handleItemClick}>
      {favicon && <S.StyledFavicon src={favicon} />}
      <S.ItemContent>
        <S.LinkUrl>{url}</S.LinkUrl>
      </S.ItemContent>
    </S.ItemContainer>
  );
};
